module.exports = __webpack_public_path__ + "media/components/Agencies/Layouts/SideMenu/reportIcon-12030bcc918c4aefb1f1f26d5194a227.svg";